// components/admin/quotes/QuotesTable.jsx
import { Eye, Send, Edit, Trash2, Calendar, Euro, FileText, AlertCircle } from 'lucide-react';
import StatusBadge from './StatusBadge';
import Loader from '../../common/Loader';

export default function QuotesTable({
  quotes,
  loading,
  error,
  onView,
  onEdit,
  onDelete,
  onSend,
  formatDate,
  formatPrice,
  onCreate
}) {
  if (error) {
    return (
      <div className="quotes-table-container">
        <div className="error-state">
          <AlertCircle size={48} />
          <h3>Erreur de chargement</h3>
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="btn-secondary">
            Réessayer
          </button>
        </div>
      </div>
    );
  }
  
  if (quotes.length === 0 && !loading) {
    return (
      <div className="quotes-table-container">
        <div className="empty-state">
          <FileText size={48} />
          <h3>Aucun devis trouvé</h3>
          <p>Commencez par créer votre premier devis</p>
          <button onClick={onCreate} className="btn-primary">
            Créer un devis
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="quotes-table-container">
      <div className="table-responsive">
        <table className="quotes-table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Projet</th>
              <th>Date</th>
              <th>Montant</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((quote) => (
              <tr key={quote._id} className="quote-row">
                <td>
                  <div className="client-cell">
                    <div className="client-name">{quote.clientName}</div>
                    <div className="client-email">{quote.clientEmail}</div>
                  </div>
                </td>
                
                <td>
                  <div className="project-cell">
                    <div className="project-type">{quote.projectType}</div>
                    <div className="project-desc">
                      {quote.projectDescription?.substring(0, 60)}...
                    </div>
                  </div>
                </td>
                
                <td>
                  <div className="date-cell">
                    <Calendar size={14} />
                    {formatDate(quote.createdAt)}
                  </div>
                </td>
                
                <td>
                  <div className="amount-cell">
                    <Euro size={14} />
                    {formatPrice(quote.total)}
                  </div>
                </td>
                
                <td>
                  <StatusBadge status={quote.status} />
                </td>
                
                <td>
                  <div className="actions-cell">
                    <button
                      onClick={() => onView(quote)}
                      className="icon-btn"
                      title="Voir détails"
                    >
                      <Eye size={16} />
                    </button>
                    
                    <button
                      onClick={() => onEdit(quote)}
                      className="icon-btn"
                      title="Modifier"
                    >
                      <Edit size={16} />
                    </button>
                    
                    {quote.status === 'pending' && (
                      <button
                        onClick={() => onSend(quote._id)}
                        className="icon-btn success"
                        title="Envoyer au client"
                      >
                        <Send size={16} />
                      </button>
                    )}
                    
                    <button
                      onClick={() => onDelete(quote)}
                      className="icon-btn danger"
                      title="Supprimer"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {loading && (
        <div className="loading-overlay">
          <Loader />
          <p>Chargement des devis...</p>
        </div>
      )}
    </div>
  );
}